"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var ShareAction;
(function (ShareAction) {
    ShareAction.ON_SET_SHARE_ACTIVE = 'SHAERE_ON_SET_SHARE_ACTIVE';
    ShareAction.ON_COPY_CLICKED = 'SHAERE_ON_COPY_CLICKED';
    ShareAction.ON_SHARE_CLICKED = 'SHAERE_ON_SHARE_CLICKED';
    ShareAction.ON_INPUT_CLICKED = 'SHAERE_ON_INPUT_CLICKED';
    ShareAction.setShareActive = typesafe_actions_1.createAction(ShareAction.ON_SET_SHARE_ACTIVE, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    ShareAction.onShareClicked = typesafe_actions_1.createAction(ShareAction.ON_SHARE_CLICKED, function (resolve) { return function () {
        return resolve();
    }; });
    ShareAction.onCopyClicked = typesafe_actions_1.createAction(ShareAction.ON_COPY_CLICKED, function (resolve) { return function () {
        return resolve();
    }; });
    ShareAction.onInputClicked = typesafe_actions_1.createAction(ShareAction.ON_INPUT_CLICKED, function (resolve) { return function () {
        return resolve();
    }; });
})(ShareAction || (ShareAction = {}));
exports.default = ShareAction;
